module.exports = __webpack_public_path__ + "static/media/lnw_spark_logo.38c50ede.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lnw_spark_logo.png
// module id = 437
// module chunks = 1